(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section--header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section--header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section--header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });


  document.addEventListener("DOMContentLoaded", function () {
    const dropdownBtn = document.getElementById("verticalDropdownBtn");
    const dropdownContent = document.getElementById("verticalDropdownContent");
   
    dropdownBtn?.addEventListener("click", function () {
      dropdownContent.classList.toggle("show");
    });

    window.addEventListener("click", function (event) {
      if (!dropdownBtn?.contains(event.target) && !dropdownContent?.contains(event.target)) {
        dropdownContent?.classList.remove("show");
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section--header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();
})();
